<div class="content">
  <mat-tab-group [selectedIndex]="isInforTab" #myTabGroup (selectedIndexChange)="changeTabSelected($event)">
    <mat-tab [label]="'record_management_moha.view_employee_list' | translate">
      <app-view-employee-list *ngIf="isInforTab == 0"></app-view-employee-list>
    </mat-tab>

    <mat-tab [label]="'record_management_moha.view_dossier_list' | translate">
      <app-view-dossier-list *ngIf="isInforTab == 1"></app-view-dossier-list>
    </mat-tab>
  </mat-tab-group>
</div>